var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main-menu__cats-wrapper" },
    [
      _c("content-container", [
        _c("div", { staticClass: "wrapper" }, [
          _c(
            "div",
            { staticClass: "slider-wrapper" },
            [
              !_vm.isIE
                ? _c(
                    "button",
                    {
                      staticClass: "back-arrow-icon",
                      class: { show: _vm.showPrevArrow },
                      on: { click: _vm.prevSlide },
                    },
                    [
                      _c(
                        "icon-base",
                        {
                          attrs: {
                            width: "16px",
                            height: "14px",
                            iconName: "Scroll Back",
                          },
                        },
                        [_c("icon-arrow-right")],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isIE && _vm.menuCatsObject.length
                ? _c(
                    "VueSlickCarousel",
                    _vm._b(
                      {
                        ref: "carousel",
                        on: { afterChange: _vm.checkSlideCount },
                      },
                      "VueSlickCarousel",
                      _vm.settings,
                      false
                    ),
                    _vm._l(_vm.menuCatsObject, function (category, index) {
                      return _c(
                        "div",
                        {
                          key: category.id,
                          staticClass: "main-menu__cat-item-wrapper",
                          class: { active: category.isActive },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "main-menu__cat-item",
                              class: { active: category.isActive },
                              attrs: { index: category.index },
                              on: {
                                click: function ($event) {
                                  _vm.handleClick(category, index)
                                  _vm.scrollTo(`#${category.id}`)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(category.label) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isIE
                ? _c(
                    "div",
                    { staticClass: "main-menu__cats" },
                    _vm._l(_vm.menuCatsObject, function (category, index) {
                      return _c(
                        "div",
                        {
                          key: category.id,
                          staticClass: "main-menu__cat-item-wrapper",
                          class: { active: category.isActive },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "main-menu__cat-item",
                              class: { active: category.isActive },
                              attrs: { index: category.index },
                              on: {
                                click: function ($event) {
                                  _vm.handleClick(category, index)
                                  _vm.scrollTo(`#${category.id}`)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(category.label) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isIE
                ? _c(
                    "button",
                    {
                      staticClass: "forward-arrow-icon",
                      class: { show: _vm.showNextArrow },
                      on: { click: _vm.nextSlide },
                    },
                    [
                      _c(
                        "icon-base",
                        {
                          attrs: {
                            width: "16px",
                            height: "14px",
                            iconName: "Scroll Forward",
                          },
                        },
                        [_c("icon-arrow-right")],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "cart-button",
              attrs: { type: "button", id: "cartCountButton" },
            },
            [
              _c(
                "span",
                { staticClass: "cart-button-icon" },
                [
                  _c(
                    "icon-base",
                    {
                      attrs: {
                        width: "22px",
                        height: "22px",
                        iconName: "Cart",
                      },
                    },
                    [_c("icon-bag")],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "cart-button-text" }, [
                _vm._v(" My Order : " + _vm._s(_vm.currentCartCount) + " "),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }